import { MessageDescriptor } from "react-intl";
import messages from "../messages";

const PLACEHOLDER_COUNT = 3;

/**
 * `snake_case` → `camelCase`, the case the keys are written in. Kept local
 * rather than imported from `messageKeys`: that module is mocked wholesale by
 * the screens' tests, and a leaf util should not break when it is.
 */
const camelCase = (value: string) =>
  value
    .split("_")
    .map((part, index) =>
      index ? part.charAt(0).toUpperCase() + part.slice(1) : part
    )
    .join("");

const GENERIC = [
  messages["taskCreation.description.placeholder.generic1"],
  messages["taskCreation.description.placeholder.generic2"],
  messages["taskCreation.description.placeholder.generic3"],
];

/**
 * Placeholder copy for the description textarea (RT-4321).
 *
 * Category-specific once we know the trade — whether that came from a SEM page
 * or from the picker — and generic otherwise, which is the entry screen reached
 * with no category at all. A category whose trio is not declared falls back to
 * the generic set rather than showing a half-filled rotation.
 */
export const getPlaceholderMessages = (
  categoryKey?: string
): MessageDescriptor[] => {
  if (!categoryKey) return GENERIC;

  const table = messages as unknown as Record<string, MessageDescriptor>;
  const own = Array.from(
    { length: PLACEHOLDER_COUNT },
    (_, index) =>
      table[
        `taskCreation.${camelCase(categoryKey)}.description.placeholder${
          index + 1
        }`
      ]
  );

  return own.every(Boolean) ? own : GENERIC;
};
